import { SKELETON_LOADER_CONST } from '@constants/commonConstants';

export const MslFooterTableLoadingData = {
  data: {
    assurance: SKELETON_LOADER_CONST.LOADING,
    consulting: SKELETON_LOADER_CONST.LOADING,
    sat: SKELETON_LOADER_CONST.LOADING,
    tax: SKELETON_LOADER_CONST.LOADING,
    itts: SKELETON_LOADER_CONST.LOADING,
    emeia: SKELETON_LOADER_CONST.LOADING,
    total: SKELETON_LOADER_CONST.LOADING,
    category: SKELETON_LOADER_CONST.LOADING,
  },
  iterationCount: 8,
};

export const MslTopTableLoadingData = {
  data: {
    account_segment: SKELETON_LOADER_CONST.LOADING,
    assurance: SKELETON_LOADER_CONST.LOADING,
    consulting: SKELETON_LOADER_CONST.LOADING,
    sat: SKELETON_LOADER_CONST.LOADING,
    tax: SKELETON_LOADER_CONST.LOADING,
    itts: SKELETON_LOADER_CONST.LOADING,
    emiaacr: SKELETON_LOADER_CONST.LOADING,
    total: SKELETON_LOADER_CONST.LOADING,
    accounts: SKELETON_LOADER_CONST.LOADING,
  },
  iterationCount: 4,
};
